module.exports = __webpack_public_path__ + "img/barometer.be3d8a0e.svg";